/**
 * 将秒数格式化为中文可读时长，如「3分25秒」「1小时2分」。
 */
export function formatDuration(seconds) {
  if (seconds == null || seconds === '') return '—'
  const s = Math.max(0, Math.floor(Number(seconds)))
  if (Number.isNaN(s)) return '—'
  if (s === 0) return '—'

  const h = Math.floor(s / 3600)
  const m = Math.floor((s % 3600) / 60)
  const sec = s % 60
  const parts = []
  if (h > 0) parts.push(`${h}小时`)
  if (m > 0) parts.push(`${m}分钟`)
  if (sec > 0 && h === 0) parts.push(`${sec}秒`)
  if (parts.length === 0) return '不到 1 分钟'
  return parts.join('')
}
